import { Link } from "react-router-dom";
import { showInfo } from "@/mocks/content";

export default function HeroSection() {
  const genreTags = showInfo.genre.split(" · ");

  return (
    <section className="mx-auto w-full max-w-content px-4 pt-8 md:px-6 md:pt-10">
      <div className="relative w-full overflow-hidden rounded-xl">
        <img
          src={showInfo.heroCover}
          alt={`${showInfo.name} 主视觉`}
          title={`${showInfo.name} - 影视剧剧情介绍与精彩点评`}
          className="absolute inset-0 h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/65 to-foreground-950/20"></div>

        <div className="relative z-10 flex min-h-[440px] w-full flex-col justify-center gap-5 p-6 md:min-h-[560px] md:p-12 lg:max-w-[680px]">
          <div className="flex flex-wrap items-center gap-2">
            <span className="rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-foreground-950">
              正在热播
            </span>
            {genreTags.map((tag) => (
              <span
                key={tag}
                className="rounded-full border border-background-50/40 px-3 py-1 text-xs text-background-50"
              >
                {tag}
              </span>
            ))}
          </div>

          <div>
            <h1 className="font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl">
              {showInfo.name}
            </h1>
            <p className="mt-3 text-base text-accent-300 md:text-lg">{showInfo.tagline}</p>
          </div>

          <p className="max-w-xl text-sm leading-relaxed text-background-100 md:text-base">
            {showInfo.intro}
          </p>

          <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-background-200 md:text-sm">
            <span className="flex items-center gap-1.5">
              <i className="ri-star-fill text-accent-400"></i>
              评分 {showInfo.rating}
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-calendar-line"></i>
              {showInfo.year}
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-stack-line"></i>
              {showInfo.episodes}
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-movie-2-line"></i>
              导演 {showInfo.director}
            </span>
          </div>

          <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
            <Link
              to="/category/plot"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-semibold text-foreground-950 transition-colors hover:bg-accent-400"
            >
              <i className="ri-book-open-line"></i>
              查看剧情介绍
            </Link>
            <Link
              to="/category/news"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/50 bg-background-50/10 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/20"
            >
              <i className="ri-notification-3-line"></i>
              追踪最新动态
            </Link>
          </div>

          <div className="flex items-center gap-2 rounded-md border border-background-50/25 bg-foreground-950/30 px-3 py-2 text-xs text-background-100 md:text-sm">
            <i className="ri-play-circle-line text-base text-accent-400"></i>
            <span>{showInfo.watchNote}</span>
          </div>
        </div>
      </div>
    </section>
  );
}